import type { CSSProperties } from 'react';

/** A tour's colour as a CSS variable; the stylesheet turns it into a light background (light and dark themes). */
export function tourTint(color: unknown): CSSProperties | undefined {
  const c = typeof color === 'string' && /^#[0-9a-fA-F]{6}$/.test(color) ? color : '';
  return c ? ({ '--tour': c } as CSSProperties) : undefined;
}
